import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b449bff2-a271-4cbe-9cad-1f6cd5dbd33a/artifacts/y4otwih5_20251110%20tl%20charity%20design%20%26%20identity%20V01-02.png";

const DonationSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="flex justify-center mb-8">
          <img
            src={LOGO_URL}
            alt="TL Charity Logo"
            className="h-20 w-auto"
          />
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-12 text-center border border-gray-200">
          <div className="bg-green-100 rounded-full p-4 w-20 h-20 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-12 w-12 text-green-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Vielen Dank für Ihre Spende!
          </h1>
          <p className="text-gray-600 text-xl mb-8 leading-relaxed">
            Ihre Spende wurde erfolgreich übermittelt.
          </p>
          <p className="text-gray-600 text-lg mb-8">
            Mit Ihrer Hilfe schützen wir bedrohte Wälder und bewahren die Lunge unseres Planeten. 
            Sie erhalten in Kürze eine Bestätigungs-E-Mail.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-[#FF1B8D] hover:bg-[#E01679] text-white px-8 py-6 rounded-full text-lg font-semibold"
            >
              Zur Startseite
            </Button>
            <Button
              onClick={() => navigate('/#projects')}
              variant="outline"
              className="border-2 border-[#FF1B8D] text-[#FF1B8D] hover:bg-[#FF1B8D] hover:text-white px-8 py-6 rounded-full text-lg font-semibold"
            >
              Projekte ansehen
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationSuccess;
